/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  getWhatsappAnalytics(inboxId, startDate, endDate) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_analytics`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  getWhatsappBmInsights(inboxId, startDate, endDate) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_bm_insights`, {
      params: { start_date: startDate, end_date: endDate },
    });
  }
}

export default new InboxHealthAPI();
